import { render, staticRenderFns } from "./LicitacaoImpugnacaoTabela.vue?vue&type=template&id=38e46a09&scoped=true"
import script from "./LicitacaoImpugnacaoTabela.vue?vue&type=script&lang=js"
export * from "./LicitacaoImpugnacaoTabela.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoImpugnacaoTabela.vue?vue&type=style&index=0&id=38e46a09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e46a09",
  null
  
)

export default component.exports